export default __webpack_public_path__ + "static/media/carousel2.2a864db7.jpg";